import React from "react";
import { skills } from "../data";
import "./Skills.css";
import { Image } from "react-bootstrap";

function Skills() {
  const renderSkills = (skill, index) => {
    return (
      <span key={index}>
        <a href={skill.link}
           target="_blank"
        >
        <Image
          src={skill.imgSrc}
          alt={skill.imgAltText}
          className="image-style"
        ></Image>
        </a>
        <p>{skill.skillName}</p>
      </span>
    );
  };

  return (
    <div id="skills" className="skills">
      <h1>Skills & Technologies</h1>
      <p className="desc">
        These are the skills and technologies that I have picked up over the
        last year of learning how to code.
      </p>
      <div className="skillContainer">
        <div className="frontend hv">
          <h2 className="skillTitle">Frontend</h2> <hr></hr>
          {skills.frontend.map(renderSkills)}
        </div>
        <div className="backend hv">
          <h2 className="skillTitle">Backend</h2> <hr></hr>
          <div className="flex-style-1">
            {skills.backend.map(renderSkills)}
          </div>
        </div>
        <div className="hostingPlatforms hv">
          <h2 className="skillTitle">Hosting Platforms</h2> <hr></hr>
          <div className="flex-style-1">
            {skills.hostingPlatforms.map(renderSkills)}
          </div>
        </div>
        <div className="versionControl hv">
          <h2 className="skillTitle">Version Control</h2> <hr></hr>
          {skills.versionControl.map(renderSkills)}
        </div>
        <div className="programmingLanguages hv">
          <h2 className="skillTitle">Languages</h2> <hr></hr>
          {skills.programmingLanguages.map(renderSkills)}
        </div>
        <div className="databases hv">
          <h2 className="skillTitle">Databases</h2> <hr></hr>
          <div className="flex-style-1">
            {skills.databases.map(renderSkills)}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Skills;
